import { api } from '@/lib/api'
import { defaultPaginationMeta, parseMasterCatalogResponse } from '@/lib/api/masterCatalog'

/** @typedef {import('@/types/api').ServiceCategory} ServiceCategory */

export const GENDER_SCOPE_OPTIONS = [
  { value: 'ladies', label: 'Ladies' },
  { value: 'gents', label: 'Gents' },
  { value: 'all', label: 'All' },
]

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<{ items: ServiceCategory[], meta: import('@/types/api').PaginationMeta }>}
 */
export async function fetchServiceCategoriesPage(params = {}) {
  const { data } = await api.get('/masters/service-categories', { params })
  const parsed = parseMasterCatalogResponse(data, 'categories')
  return {
    items: parsed.items,
    meta: defaultPaginationMeta(parsed.meta ?? {}),
  }
}

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<ServiceCategory[]>}
 */
export async function fetchServiceCategoriesList(params = {}) {
  const { data } = await api.get('/masters/service-categories', { params })
  return data.data.categories
}

/**
 * @returns {Promise<ServiceCategory[]>}
 */
export async function fetchServiceCategories() {
  return fetchServiceCategoriesList()
}

/**
 * @param {number} categoryId
 * @returns {Promise<ServiceCategory>}
 */
export async function fetchServiceCategory(categoryId) {
  const { data } = await api.get(`/masters/service-categories/${categoryId}`)
  return data.data.category
}

/**
 * @param {Partial<ServiceCategory>} payload
 * @returns {Promise<ServiceCategory>}
 */
export async function createServiceCategory(payload) {
  const { data } = await api.post('/masters/service-categories', payload)
  return data.data.category
}

/**
 * @param {number} categoryId
 * @param {Partial<ServiceCategory>} payload
 * @returns {Promise<ServiceCategory>}
 */
export async function updateServiceCategory(categoryId, payload) {
  const { data } = await api.put(`/masters/service-categories/${categoryId}`, payload)
  return data.data.category
}

/**
 * @param {number} categoryId
 * @returns {Promise<void>}
 */
export async function deleteServiceCategory(categoryId) {
  await api.delete(`/masters/service-categories/${categoryId}`)
}
